export default "__VITE_ASSET__89332ada__"